import { createSlice } from '@reduxjs/toolkit';
import { doGetSustainabilityData } from './thunk';
import { RootState } from '@/redux/store';

export interface SustainabilityData {
  lastMile: {
    attempts: number;
    emissionPerOrder: number;
    totalEmissions: number;
    averageDistance: number;
    benchmarkTotalEmissions: number;
    transport: Record<string, number>;
  };
}

type SustainabilityState = {
  isFetching: boolean;
  sustainabilityData: any;
};

const isActionWithPending = (action: any) => {
  return action.type && action.type.startsWith('sustainability/') && action.type.endsWith('/pending');
};

const isActionWithFulfilled = (action: any) => {
  return action.type && action.type.startsWith('sustainability/') && action.type.endsWith('/fulfilled');
};

const isActionWithFailed = (action: any) => {
  return action.type && action.type.startsWith('sustainability/') && action.type.endsWith('/rejected');
};

const initialState: SustainabilityState = {
  isFetching: false,
  sustainabilityData: null,
};

const sustainabilitySlice = createSlice({
  name: 'sustainability',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetSustainabilityData.fulfilled, (state, action) => {
      state.sustainabilityData = action.payload;
      state.isFetching = false;
    });
    builder.addCase(doGetSustainabilityData.pending, (state) => {
      state.isFetching = true;
    });
    builder.addMatcher(isActionWithPending, (state) => {
      state.isFetching = true;
    });
    builder.addMatcher(isActionWithFulfilled, (state) => {
      state.isFetching = false;
    });
    builder.addMatcher(isActionWithFailed, (state) => {
      state.isFetching = false;
    });
  },
});

export const selectSustainabilityData = (state: RootState) => state.sustainability.sustainabilityData;

const { reducer: sustainabilityReducer } = sustainabilitySlice;
export default sustainabilityReducer;
